var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',[_c('div',{staticClass:"welcome"},[_c('h1',[_vm._v("Submission Successful!"),_c('br'),_vm._v("Thank you for choosing Greendoor.")]),_c('div',[_vm._v(" We will contact you in 1 - 2 business days to review your China page together with you. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }